module.exports = __webpack_public_path__ + "img/25b63c9.jpg";